<div class="card">
    <div class="card-header">
        <h5>{{ "PROPERTIES.Međuspremnik" | translate }}</h5>
    </div>
    <div class="card-body mb-0">
        <div class="row" id="report-export">
            <div class="common-fiwe">
                <div class="recent-table table-responsive custom-scrollbar invoice-table">
                    <table class="table">
                        <thead>
                            <tr>
                                <th>
                                    {{"PROPERTIES.Firma" | translate}}
                                </th>

                                <th>
                                    {{"PROPERTIES.Tip" | translate}}
                                </th>

                                <th>
                                    {{"PROPERTIES.Datum" | translate}}
                                </th>

                                <th class="icons-column"></th>
                            </tr>
                        </thead>

                        <tbody>
                            <tr *ngFor="let item of clips; index as i">
                                <td>
                                    <p class="c-o-light">{{ item?.firme?.naziv }}</p>
                                </td>

                                <td>
                                    <p class="c-o-light">{{ getTip( item?.tip ) }}</p>
                                </td>

                                <td>
                                    <p class="c-o-light">{{ item?.date | date :"dd.MM.yyyy. HH:mm" }}</p>
                                </td>

                                <td class="icons-column">
                                    <div class="d-flex justify-content-center flex-nowrap">
                                        <div class="d-flex align-items-center px-2" (click)="pasteClipboard(item)">
                                            <div class="d-flex justify-content-center align-items-center px-1">
                                                <a placement="top" *ngIf="!isPasting"
                                                    [ngbTooltip]="'PROPERTIES.Zalijepi kopirano' | translate"
                                                    class="btn btn-xs quare-white"><i
                                                        class="fa fa-paste fa-fw fa-lg"></i>
                                                </a>

                                                <span class="spinner-border spinner-border-sm text-dark ms-1"
                                                    role="status" *ngIf="isPasting">
                                                    <span class="sr-only">Loading...</span>
                                                </span>
                                            </div>
                                        </div>

                                        <div class="d-flex align-items-center px-2" (click)="delete(item)">
                                            <div class="d-flex justify-content-center align-items-center px-1">
                                                <a placement="top" [ngbTooltip]="'PROPERTIES.Obriši' | translate"
                                                    class="btn btn-xs quare-white"><i
                                                        class="fa fa-trash fa-fw fa-lg"></i>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>

                    <div *ngIf="loading" class="loader-box">
                        <div class="loader-2"></div>
                    </div>
                </div>
            </div>

            <div class="col-12 text-end mt-2 mb-0 me-2">
                <button class="btn btn-light me-2 ms-2" (click)="closeModal( )" type="button">
                    {{"PROPERTIES.Zatvori" | translate}}
                </button>
            </div>

        </div>
    </div>
</div>